import type { IconNode } from '../types';

/**
 * @name spider
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8cGF0aCBkPSJNMTAgNXYxIiAvPgogIDxwYXRoIGQ9Ik0xNCA2VjUiIC8+CiAgPHBhdGggZD0iTTEwIDEwLjRWOGEyIDIgMCAxIDEgNCAwdjIuNCIgLz4KICA8cGF0aCBkPSJNNyAxNUg0bC0yIDIuNSIgLz4KICA8cGF0aCBkPSJNNy40MiAxNyA1IDIwbDEgMiIgLz4KICA8cGF0aCBkPSJtOCAxMi00LTEtMi0zIiAvPgogIDxwYXRoIGQ9Ik05IDExIDUuNSA2IDcgMiIgLz4KICA8cGF0aCBkPSJNOCAxOGE1IDUgMCAxIDEgOCAwcy0yIDMtNCA0Yy0yLTEtNC00LTQtNCIgLz4KICA8cGF0aCBkPSJtMTUgMTEgMy41LTVMMTcgMiIgLz4KICA8cGF0aCBkPSJtMTYgMTIgNC0xIDItMyIgLz4KICA8cGF0aCBkPSJNMTcgMTVoM2wyIDIuNSIgLz4KICA8cGF0aCBkPSJNMTYuNTcgMTcgMTkgMjBsLTEgMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/spider
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const spider: IconNode = [
  ['path', { d: 'M10 5v1', key: '1pxikn' }],
  ['path', { d: 'M14 6V5', key: 'a5hu07' }],
  ['path', { d: 'M10 10.4V8a2 2 0 1 1 4 0v2.4', key: 'p94354' }],
  ['path', { d: 'M7 15H4l-2 2.5', key: '9kpgv6' }],
  ['path', { d: 'M7.42 17 5 20l1 2', key: '1p4x5p' }],
  ['path', { d: 'm8 12-4-1-2-3', key: '1ex0fl' }],
  ['path', { d: 'M9 11 5.5 6 7 2', key: '1p8e03' }],
  ['path', { d: 'M8 18a5 5 0 1 1 8 0s-2 3-4 4c-2-1-4-4-4-4', key: '1tjoez' }],
  ['path', { d: 'm15 11 3.5-5L17 2', key: '4l7k6z' }],
  ['path', { d: 'm16 12 4-1 2-3', key: '1c8q6u' }],
  ['path', { d: 'M17 15h3l2 2.5', key: '1bzrgh' }],
  ['path', { d: 'M16.57 17 19 20l-1 2', key: '1ghfxl' }],
];

export default spider;
